import api from "./api";
import apiFunctions from "./functions";

/**
 * Retorna una lista con los datos de las plantas
 *
 * @returns {Promise<Object>} Promesa que resuelve en una lista con los datos de las plantas
 */
export const getPlantasData = () => {
    return new Promise((resolve) => {
        apiFunctions.get(
            api.dependencias.plantasselect,
            null,
            null,
            null,
            (response) => {
                resolve(response.data);
            },
        );
    });
}
/**
 * Retorna una lista con los datos de las areas (Lugares de entrega).
 *
 * @returns {Promise<Object>} Promesa que resuelve en una lista con los datos de las areas (lugares de entrega).
 */
export const getLugaresEntregaData = () => {
    const parameters = { pageSize: 100 }; // Para traer a todas las areas (el codigo es de 2 digitos)

    return new Promise((resolve) => {
        apiFunctions.get(
            api.personas.areasselect,
            null,
            null,
            parameters,
            (response) => {
                resolve(response.data);
            },
        );
    });
}

/**
 * Retorna una lista con los datos de los comedores (la "Planta" de un pedido de
 * producto).
 *
 * Se trae la lista completa en vez de dejar que el select la pida por su cuenta
 * porque el formulario necesita leerla: la regla del lugar de entrega de Galván
 * depende del nombre del comedor elegido.
 *
 * @returns {Promise<Object>} Promesa que resuelve en una lista con los datos de los comedores
 */
export const getComedoresData = () => {
    const parameters = { paginationEnabled: false };

    return new Promise((resolve) => {
        apiFunctions.get(
            api.comedor.comedorSelect,
            null,
            null,
            parameters,
            (response) => {
                resolve(response.data);
            },
        );
    });
}

/**
 * Retorna una lista con los datos de los Centros de Costo
 *
 * @returns {Promise<Object>} Promesa que resuelve en una lista con los datos de los Centros de Costo
 */
export const getCentrosCostoData = () => {
    const parameters = { pageSize: 1000 };

    return new Promise((resolve) => {
        apiFunctions.get(
            api.dependencias.dependenciasselect,
            null,
            null,
            parameters,
            (response) => {
                resolve(response.data);
            },
        );
    });
}

/**
 * Retorna una lista con los datos de las Personas que pueden pedir el menú
 * diario pasado por parametro. No se puede repetir un pedido de vianda para
 * aquellas personas que ya pidieron un menú diario para ese turno.
 *
 * @returns {Promise<Object>} Promesa que resuelve en una lista con los datos de las Personas
 */
export const getPersonasData = (menuDiarioId) => {
    const parameters = { pageSize: 9000 }; // Para traer a todas las personas

    // El menú diario es parte del path, sin el no hay endpoint que llamar.
    if (!menuDiarioId) return Promise.resolve([]);

    return new Promise((resolve) => {
        apiFunctions.get(
            api.personas.personasSelectMenuDiario(menuDiarioId),
            null,
            null,
            parameters,
            (response) => {
                resolve(response.data);
            },
        );
    });
}

/**
 * Fetches area data from the API.
 * Retorna el pedido de vianda correspondiente al codigo de verificación.
 *
 * @param {string} codigoVerificacion - Codigo de verificacion existente del pedido de vianda
 * @returns {Promise<Object>} Promesa que resuelve en los datos del pedido de vianda encontrado.
 */
export const getPedidoViandaFromCodigoVerificacion = (codigoVerificacion) => {
    return new Promise((resolve, reject) => {
        apiFunctions.get(
            api.viandas.adjuntable + codigoVerificacion,
            null,
            null,
            null,
            (response) => {
                resolve(response)
            },
            (error) => {
                reject(error)
            }
        )
    });
}

/**
 * Recupera los datos del usuario logueado actualmente.
 *
 * @returns {Promise<Object>} Promasa que resuelve con los datos del usuario logueado.
 */
export const getDatosUsuarioLogueado = () => {
    return new Promise((resolve, reject) => {
        apiFunctions.get(
            api.personas.datosPersonasUsuarios,
            null,
            null,
            null,
            (response) => {
                resolve(response)
            },
            (error) => {
                reject(error)
            }
        );
    });
}



// WEBPACK FOOTER //
// ./src/api/calls.js